import { IonIcon } from '@ionic/react';
import {
  checkmarkCircle,
  openOutline,
  playForwardOutline,
} from 'ionicons/icons';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { DuplicatePlan } from '../useDuplicatePlan';

type Props = {
  plan: DuplicatePlan;
};

/** Closing the loop: what changed, where it went, and how to undo it. */
const PlanDone: React.FC<Props> = ({ plan }) => {
  const history = useHistory();
  const {
    removedFiles,
    removedSets,
    skippedCount,
    reconciledCrates,
    repointedEntries,
    crateIndexAvailable,
  } = plan;

  return (
    <div className="dup-stage dup-done">
      <div className="dup-done-mark">
        <IonIcon icon={checkmarkCircle} />
      </div>

      {removedFiles > 0 ? (
        <>
          <h1>
            Removed <span className="dup-figure">{removedFiles}</span> duplicate
            {removedFiles === 1 ? '' : 's'}
          </h1>
          <p className="dup-lede">
            Cleaned up {removedSets} set{removedSets === 1 ? '' : 's'}. Every
            removed file is in your Recycle Bin — nothing is gone for good.
            {crateIndexAvailable && reconciledCrates > 0 && (
              <>
                {' '}
                Updated {reconciledCrates} Serato crate
                {reconciledCrates === 1 ? '' : 's'}
                {repointedEntries > 0 && (
                  <>
                    {' '}
                    ({repointedEntries} track reference
                    {repointedEntries === 1 ? '' : 's'} repointed)
                  </>
                )}
                .
              </>
            )}
          </p>
        </>
      ) : (
        <>
          <h1>Nothing was removed</h1>
          <p className="dup-lede">Your library is unchanged.</p>
        </>
      )}

      <div className="dup-done-actions">
        {removedFiles > 0 && (
          <button
            type="button"
            className="dup-btn dup-btn--ghost"
            onClick={() => history.push('/recycle-bin')}
          >
            <IonIcon icon={openOutline} />
            Open Recycle Bin
          </button>
        )}
        {skippedCount > 0 && (
          <button
            type="button"
            className="dup-btn dup-btn--quiet"
            onClick={plan.startOver}
          >
            <IonIcon icon={playForwardOutline} />
            Revisit {skippedCount} skipped set
            {skippedCount === 1 ? '' : 's'}
          </button>
        )}
      </div>
    </div>
  );
};

export default PlanDone;
